import { z } from 'zod'
import type { GETpropertiesByIDsResponse } from '../property/infrastructure/HTTPPropertyRepository/schemas/properties/ids'
import { Model } from './architecture'
import { Image } from './Image'
import { POSTRelatedResponseType } from '../property/infrastructure/HTTPPropertyRepository/schemas/related'
import { POSTBannerResponseType } from '../property/infrastructure/HTTPPropertyRepository/schemas/banner'
import { SearchProperty } from '../property/infrastructure/HTTPPropertyRepository/schemas/v3/search/legacy'

export const ListOfImageValidation = z.object({
  list: z.instanceof(Image, { message: '[ListOfImage] list is required' }).array(),
})

export class ListOfImage extends Model {
  static create({ list }: z.infer<typeof ListOfImageValidation>) {
    ListOfImageValidation.parse({ list })
    return new ListOfImage(list)
  }

  static empty() {
    return ListOfImage.create({ list: [] })
  }

  static fromAPI({ json }: { json: GETpropertiesByIDsResponse['properties'][number]['images'] }) {
    return ListOfImage.create({ list: json.map(imageJSON => Image.fromAPI({ json: imageJSON })) })
  }

  static fromJSON({ json }: { json: ReturnType<ListOfImage['toJSON']> }) {
    return ListOfImage.create({
      list: json.list.map(imageJSON => Image.fromJSON({ json: imageJSON })),
    })
  }

  static fromRelatedAPI({
    json,
  }: {
    json: POSTRelatedResponseType['properties'][number]['images']
  }) {
    return ListOfImage.create({
      list: json.map(imageJSON => Image.fromRelatedAPI({ json: imageJSON })),
    })
  }

  static fromBannerApi({ json }: { json: POSTBannerResponseType['properties'][number]['images'] }) {
    return ListOfImage.create({
      list: json.map(imageJSON => Image.fromBannerApi({ json: imageJSON })),
    })
  }

  static fromSerpApiLegacy({ json }: { json?: SearchProperty['photos'] }) {
    if (!json) return ListOfImage.empty()

    return ListOfImage.create({
      list: json.map(imageJSON => Image.fromSearchApiLegacy({ json: imageJSON })),
    })
  }

  constructor(private readonly _list: Image[]) {
    super()
  }

  get list() { return this._list } // prettier-ignore

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }

  map<T>(fn: (id: Image) => T) {
    return this._list.map(fn)
  }
}
